import { MapPin, Clock, Phone, Mail } from 'lucide-react';

import styles from './styles.module.scss';

type CafeMetaProps = {
  address: string;
  hours: string;
  phone?: string;
  email?: string;
};

const getMapsLink = (address: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export const CafeMeta = ({ address, hours, phone, email }: CafeMetaProps) => (
  <div className={styles.meta}>
    {address && (
      <a
        href={getMapsLink(address)}
        target="_blank"
        rel="noreferrer noopener"
        className={`${styles.metaItem} ${styles.link}`}
      >
        <MapPin size={16} />
        {address}
      </a>
    )}
    {hours && (
      <span className={styles.metaItem}>
        <Clock size={16} />
        {hours}
      </span>
    )}
    {phone && (
      <a href={`tel:+${phone.replace(/\s+/g, '')}`} className={`${styles.metaItem} ${styles.link}`}>
        <Phone size={16} />+{phone}
      </a>
    )}
    {email && (
      <a
        href={`mailto:${email}`}
        className={`${styles.metaItem} ${styles.link}`}
      >
        <Mail size={16} />
        {email}
      </a>
    )}
  </div>
);
